import { FormControl, MenuItem, Select, Typography } from "@mui/material";

export default function KizReturnStatusChangeField({ it, onSetReturn }) {
  return (
    <>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
        Статус КИЗ:
      </Typography>
      <FormControl fullWidth size="small" sx={{ mt: 0.5 }}>
        <Select
          variant="outlined"
          labelId={`ret-${it.id}`}
          value={it.kiz_returned ? "returned" : "withdrawn"}
          onChange={(e) => {
            const returned = e.target.value === "returned";
            onSetReturn?.(it, returned);
          }}
          size="small"
        >
          <MenuItem value="withdrawn">Продан</MenuItem>
          <MenuItem value="returned">Вернул в оборот</MenuItem>
        </Select>
      </FormControl>
    </>
  );
}
